import React, { useContext, useState, useRef, useEffect, useCallback } from 'react';
import ChatInput from './ChatInput';
import ChatMessage from './ChatMessage';
import aiLogo from '../../Images/ai-logo-grey.svg';
import { useParams } from 'react-router-dom';
import useHttp from '../../hooks/useHttp';
import { API_URL , connectAndSendMessage} from '../../services/api';
import ChatContext from '../../store/ChatContext';
import { useHistory } from 'react-router-dom';
import { message as antMessage } from 'antd';
import AuthContext from '../../store/AuthContext';
import LoadingSpinner from '../LoadingSpinner';
import { getPathFromContext } from '../../utils/pathUtils';
import { generateUUID } from '../../utils/generateUUID';
import { groupChatsByDate } from '../../utils/DateUtils';
import Markdown from 'markdown-to-jsx'
import he from 'he';
import { DownOutlined } from '@ant-design/icons';

const ChatBox = (props) => {
  const { newChat = true } = props;
  const [isNewChat, setIsNewChat] = useState(newChat);
  const { chatIdentifier: originalChatIdentifier } = useParams();
  const chatCtx = useContext(ChatContext);
  const { getRequest, postRequest } = useHttp();
  const [isLoading, setIsLoading] = useState(false);
  const history = useHistory();
  const [messageSendTriggered, setMessageSendTriggered] = useState(false);
  const [messages, setMessages] = useState(history?.location?.state?.historyMessages || []);
  const authCtx = useContext(AuthContext);
  const lastUserMessageRef = useRef(null);

  const [chatResponse, setChatResponse] = useState("");
  const [streamText, setStreamText] = useState("");
  const [isThinking, setIsThinking] = useState(false);
  const [thinkingContent, setThinkingContent] = useState("");
  const [thinkingContentList, setThinkingContentList] = useState([]);
  const [showThinkingText, setShowThinkingText] = useState(false);
  const thinkingRef = useRef([]);
  const thinkingIndexRef = useRef(0);
  const thinkingTimerRef = useRef(null);
  const hasReceivedThinkingRef = useRef(false);
  const chatContainerRef = useRef(null);
  const [showScrollButton, setShowScrollButton] = useState(false);
  const [connectionId, setConnectionId] = useState(null);

  const scrollToBottom = () => {
    const container = document.querySelector(".chat-container");
    if (container) {
      container.scrollTo({
        top: container.scrollHeight,
        behavior: 'smooth'
      });
      // Check position after scroll animation completes
      setTimeout(() => {
        checkScrollPosition();
      }, 50);
    }
  };

  const checkScrollPosition = useCallback(() => {
    const container = chatContainerRef.current;
    if (!container) return;
    
    const { scrollTop, scrollHeight, clientHeight } = container;
    const isScrollable = scrollHeight > clientHeight;
    const isNearBottom = scrollHeight - scrollTop - clientHeight < 50; // 100px threshold
    
    setShowScrollButton(isScrollable && !isNearBottom);
  }, []);

  const MyCustomLink = ({ children, ...props }) => (
    <a {...props} target="_blank" rel="noopener noreferrer">{children}</a>
  );

  const MyCustomTable = ({ children, ...props }) => (
    <div className="max-w-full overflow-auto max-h-[250px] chatTable">
      <table {...props}>{children}</table>
    </div>
  );

  // Check if this is a new chat identifier
  const isNewChatIdentifier = originalChatIdentifier === 'newChat' || 
                               originalChatIdentifier === 'new' || 
                               (originalChatIdentifier && originalChatIdentifier.startsWith('new-'));
  
  // Use null for new chats, otherwise use the original identifier
  const chatIdentifier = isNewChatIdentifier ? null : originalChatIdentifier;

  const activeChatRef = useRef(null);

  
  useEffect(() => {
    chatCtx.setConnectionId(chatIdentifier);
    setConnectionId(chatIdentifier);
  }, [chatIdentifier]);
  
  useEffect(() => {
    activeChatRef.current = chatCtx.connectionId || null;
  }, [chatCtx.connectionId]);

  useEffect(() => {
    // Reset state when navigating to a new chat
    if (isNewChatIdentifier) {
      setMessages([]);
      setStreamText("");
      setChatResponse("");
      setIsThinking(false);
      setThinkingContent("");
      setThinkingContentList([]);
      setShowThinkingText(false);
      setIsNewChat(true);
      chatCtx.setChatTitle(null);
      if (authCtx.userDetails?.employerOrgEin) {
        getRequest({
          url: API_URL + '/app/ap1/agent/createConnection',
          onResponse: (response) => {
            if (response.chatIdentifier) {
              chatCtx.setConnectionId(response.chatIdentifier);
              setConnectionId(response.chatIdentifier);
            }
          },
          onError: (error) => {
            console.error('Error fetching connect ID:', error);
          }
        });
      }
      return;
    }
    
    else if (chatIdentifier && !history?.location?.state?.historyMessages) {
      setIsNewChat(false);
      // const contextPath = chatCtx.agentId ?
      //   getPathFromContext(chatCtx) : 'ap1';
        const contextPath = getPathFromContext(chatCtx);
      getRequest({
        url: API_URL + '/app/' + contextPath + '/agent/chat/fetch?chatIdentifier=' + chatIdentifier,
        onResponse: (response) => {
          let messages = [];
          if (response && response.length > 0) {
            response.forEach(item => {
              messages.push({
                content: item.chatMessageSource === 'USER' ? item.agenticMessageDTO?.userMessage : item.chatMessage,
                isUser: item.chatMessageSource === 'USER',
                files: item.agenticMessageDTO?.agenticFiles || [],
                userChatSentiment: item.userChatSentiment,
                chatMessageIdentifier: item.chatMessageIdentifier,
                messageDate: item.messageDate
              });
            });
            setMessages(messages);
            setMessageSendTriggered(true);
            chatCtx.setChatTitle(response[0].chatTitle);
            chatCtx.setAgentId(response[0].agentId);
          } else {
            antMessage.error({
              content: 'This chat is no longer available',
              duration: 1,
            });
            history.push('/chat');
          }
        },
        onError: (error) => {
          console.error('Error fetching chat history:', error);
          antMessage.error({
            content: 'This chat is no longer available',
            duration: 1,
          });
          history.push('/chat');
        }
      });
    } else if (chatIdentifier && history?.location?.state?.historyMessages) {
      setIsNewChat(false);
    } else {
      setIsNewChat(true);
      chatCtx.setChatTitle(null);
      if (authCtx.userDetails?.employerOrgEin) {
        getRequest({
          url: API_URL + '/app/ap1/agent/createConnection',
          onResponse: (response) => {
            if (response.chatIdentifier) {
              chatCtx.setConnectionId(response.chatIdentifier);

            }
          },
          onError: (error) => {
            console.error('Error fetching connect ID:', error);
          }
        });
      }
    }
  }, [originalChatIdentifier, authCtx.userDetails?.employerOrgEin]);

  useEffect(() => {
    if (lastUserMessageRef.current) {
      const container = lastUserMessageRef.current.closest('.chat-container');
      if (container) {
        const elementTop = lastUserMessageRef.current.offsetTop;
        const containerHeight = container.clientHeight;
        // Position at 90% from the top with smooth scrolling
        container.style.scrollBehavior = 'smooth';
        container.scrollTop = elementTop - (containerHeight * 0.2);
      }
    }
  }, [messages]);


  useEffect(() => {
    window._charQueue = []; // each item = one character
  
    const interval = setInterval(() => {
      if (window._charQueue.length > 0) {
        const nextChar = window._charQueue.shift(); // remove first
        setStreamText(prev => prev + nextChar);
      }
    }, 1);  // ← smooth real typing (adjust between 10–25 ms)
  
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    // const container = document.querySelector(".chat-container");
    // if (container) container.scrollTop = container.scrollHeight;
    // Only scroll when a final response is added (not during stream typing)
    if (!streamText && messages.length > 0) {
      const container = document.querySelector(".chat-container");
      if (container) container.scrollTop = container.scrollHeight;
    }
  }, [streamText, messages]);

  // Check scroll position when content changes
  useEffect(() => {
    checkScrollPosition();
  }, [messages, streamText, isThinking, thinkingContent, checkScrollPosition]);

  // Set up scroll event listener
  useEffect(() => {
    const container = chatContainerRef.current;
    if (!container) return;

    container.addEventListener('scroll', checkScrollPosition);
    // Also check on resize
    window.addEventListener('resize', checkScrollPosition);

    return () => {
      container.removeEventListener('scroll', checkScrollPosition);
      window.removeEventListener('resize', checkScrollPosition);
    };
  }, [checkScrollPosition]);


  useEffect(() => {
    // when visible chat changes, clear streaming UI for this mounted component
    setStreamText("");
    setIsThinking(false);
    setThinkingContent("");
    setThinkingContentList([]);
    setShowThinkingText(false);
    // clear char queue as well (only for UI; does not cancel server send)
    if (Array.isArray(window._charQueue)) window._charQueue.length = 0;
  }, [activeChatRef.current]);

  useEffect(() => {
    if (
      (showThinkingText || thinkingContent) &&
      connectionId === chatCtx.connectionId
    ) {
      scrollToBottom();
    }
  }, [showThinkingText, thinkingContent, connectionId]);


  function showErrorMessage(isStreaming) {
    setStreamText("");
    setIsThinking(false);
    setThinkingContentList([]);
    setThinkingContent("");
    setShowThinkingText(false);
    if(isStreaming){
      var errorMessage = "Apologies, I couldn't retrieve the details at the moment. Please try again later. Thank you.";

      setIsLoading(false);
      let index = 0;
      const interval = setInterval(() => {
        if (index < errorMessage.length) {
          setStreamText((prev) => prev + errorMessage[index]);
          index++;
        } else {
          clearInterval(interval);
          setMessages((prevMessages) => {
            const newMessages = [
              ...prevMessages,
              { content: /*error.message*/ "Apologies, I couldn't retrieve the details at the moment. Please try again later. Thank you.", isUser: false, chatMessageIdentifier: 'error', messageDate: new Date().getTime() }
            ];
            return newMessages;
          });
          setStreamText("");
          setIsLoading(false);
        }
      }, 30)

    }else{
      setMessages((prevMessages) => {
        const newMessages = [
          ...prevMessages,
          { content: /*error.message*/ "Apologies, I couldn't retrieve the details at the moment. Please try again later. Thank you.", isUser: false, chatMessageIdentifier: 'error', messageDate: new Date().getTime() }
        ];
        return newMessages;
      });
      setIsLoading(false);
    }
  }

  function updateChatSectionChatTitleList(){
    getRequest({
      url: API_URL + `/app/ap1/agent/chat/fetch/all`,
      onResponse: (response) => {
        chatCtx.setChatSectionChatTitleList(groupChatsByDate(response));
        setIsLoading(false);
      }, 
      showLoader: false
    });
  }

  function getChatTitle(chatIdentifier){
    getRequest({
      url: API_URL + '/app/agentmgr/agent/chat/title/' + chatIdentifier,
      onResponse: (response) => {
        updateChatSectionChatTitleList();        
      },
      onError: (error) => {
        console.error('Error fetching chat title:', error);
      },
      showLoader: false
    });
  }


  let isProcessing = false;

function processThinkingQueue() {
  if (isProcessing) return;
  isProcessing = true;

  const run = () => {
    if (thinkingRef.current.length === 0) {
      // No more items → stop, leave last shown
      isProcessing = false;
      return;
    }

    // FIFO — take first item only
    const next = thinkingRef.current.shift();

    setThinkingContent(next);
    setShowThinkingText(false);

    // Update UI list display
    setThinkingContentList([...thinkingRef.current]);

    // Wait 1500ms before next
    setTimeout(run, 1500);
  };

  run();
}


  function updateThinkingContent(thinkingContent,connectionIdFromSerer) {
    if (activeChatRef.current !== connectionIdFromSerer) return;  // ignore wrong chat
    hasReceivedThinkingRef.current = true;  // ← IMPORTANT
    setIsLoading(false);
    setConnectionId(connectionIdFromSerer);
    thinkingRef.current.push(thinkingContent);
    setThinkingContentList([...thinkingRef.current]);
    scrollToBottom();
  
    processThinkingQueue();
  }

  function updateLoadingStateToFalseAndShowThinkingText(sendConnectionId){
     // Only show "Thinking..." for the active visible chat that matches this send
      if (activeChatRef.current !== sendConnectionId) return;
      setIsLoading(false);

      // Only show "Thinking..." if there are no queued thinking items (meaning server wants a generic "thinking")
      if (thinkingRef.current.length === 0) {
        setShowThinkingText(true);
      } else {
        setShowThinkingText(false);
      }
  }



  const onMessageSend2 = async (userMessage, files) => {

    if (!userMessage.trim() && files.length === 0) return;
  
    const identifier = generateUUID();
  
    setIsLoading(true);
    const wasNewChat = isNewChat;
    setIsNewChat(false);
    const formattedFiles = files.map(file => ({
      url: URL.createObjectURL(file),
      fileName: file.name
    }));
  
    // push user message
    if (wasNewChat) {
      setMessages([{ content: userMessage, isUser: true, files: formattedFiles, messageDate: new Date().getTime() }]);
    } else {
      setMessages([...messages, { content: userMessage, isUser: true, files: formattedFiles, messageDate: new Date().getTime() }]);
    }
  
    setMessageSendTriggered(true);
  
    // build payload
    const _postData = new FormData();
    _postData.append('userMessage', userMessage);
    _postData.append('messageSource', 'USER');
    _postData.append('memoryId', chatCtx.connectionId);
    _postData.append('messageIdentifier', identifier);
  
    files.forEach((file, index) => {
      _postData.append(`files[${index}]`, file);
    });
  
    if (chatCtx.chatTitle) {
      _postData.append('chatTitle', chatCtx.chatTitle);
    }
  
    let url = API_URL + '/app/agentmgr/agent/chat/route?agentId=requestRouterAgent-001';
  
    try {
      setStreamText("");
      setChatResponse("");
      setIsThinking(true);
      setThinkingContent("");
      setThinkingContentList([]);
      setShowThinkingText(false);
      thinkingRef.current = [];
      thinkingIndexRef.current = 0;
      thinkingTimerRef.current = null;
      hasReceivedThinkingRef.current = false;
      const sendConnectionId = chatCtx.connectionId;
  
      await connectAndSendMessage(
        identifier,
        userMessage,
        // ---------- FINAL RESPONSE ----------
        (final,chatMessageIdentifier) => {

            if (activeChatRef.current !== sendConnectionId) return;  // ignore wrong chat identifier
            setIsLoading(false);
            chatCtx.setChatTitle("agent response FINAL");
  
            // Wait until streaming finishes
            const waitUntilDone = setInterval(() => {
              if (window._charQueue.length === 0) {
                clearInterval(waitUntilDone);
  
                setStreamText("");
                setIsThinking(false);
                setThinkingContentList([]);
                setThinkingContent("");
                setShowThinkingText(false);
                // Now safely append final message AFTER typing animation.
                setMessages((prev) => [
                  ...prev,
                  {
                    content: final,
                    isUser: false,
                    chatMessageIdentifier: chatMessageIdentifier,
                    messageDate: new Date().getTime()
                  }
                ]);
                setMessageSendTriggered(true);
              }
            }, 50);
        },
  
        // ---------- SMOOTH PARTIAL STREAMING ----------
        (partial) => {
          setIsLoading(false);
          try {
            if (activeChatRef.current !== sendConnectionId) return;  // ignore wrong chat identifier
            const parsed = JSON.parse(partial);
            const text = parsed?.content || "";
          
            for (const ch of text) {
              window._charQueue.push(ch);  // push characters
            }
          } catch {
            for (const ch of partial) {
              window._charQueue.push(ch);
            }
          }
        },
  
        chatCtx.token,
        showErrorMessage,
        _postData,
        url,wasNewChat,getChatTitle,chatCtx.connectionId,updateThinkingContent,updateLoadingStateToFalseAndShowThinkingText.bind(null, sendConnectionId)
        ,hasReceivedThinkingRef
      );
  
      setIsLoading(false);
  
    } catch (err) {
      console.error("❌ Error:", err);
    }
  };

  return <>
    {isNewChat ? (
      <div className="flex flex-col justify-center h-full w-full">
        <div className="text-center w-full mx-auto p-2 lg:p-8">
          <img src={aiLogo} alt="AI Assistant" className="w-24 sm:w-18 h-24 sm:h-18 mx-auto mb-2 smallframe" />
          <h1 className="text-3xl font-semibold mb-4">What can I help with?</h1>
          <ChatInput
            showPredefinedPrompts={true}
            onSend={onMessageSend2}
            className="w-full sm:w-[80%] mx-auto"
          />
          <p className="text-xs text-gray-500 mt-1">
            AI may make mistakes, please use with discretion.
          </p>
        </div>
      </div>
    ) : (
      <div className="flex flex-col">
        <div className="flex-1 overflow-y-auto" ref={(el) => {
          if (el) {
            if (messageSendTriggered) {
              el.scrollTop = el.scrollHeight;
              setMessageSendTriggered(false);
            }
          }
        }} >

          <div 
            className="chat-container p-6 space-y-6 max-h-[calc(100vh-190px)] sm:max-h-[calc(100vh-230px)] overflow-y-auto"
            ref={chatContainerRef}
          >

            {/* ✅ Final Chat Messages */}
            {messages.map((message, index) => {
              
              
              if (message.isUser) {
                const isLastUserMessage =
                  messages.slice(index + 1).findIndex((m) => m.isUser) === -1;
                return (
                  <div
                    key={message.chatMessageIdentifier}
                    ref={isLastUserMessage ? lastUserMessageRef : null}
                  >
                    <ChatMessage message={message} setMessages={setMessages} />
                  </div>
                );
              }
              return (
                 ( 
                <ChatMessage
                  key={message.chatMessageIdentifier}
                  message={message}
                  setMessages={setMessages}
                /> )
              );

              
            })}

            {isThinking && thinkingContent && connectionId === chatCtx.connectionId && (
                <div className="flex items-center text-gray-500 font-medium">
                  <span className="animate-pulse">{thinkingContent}</span>
                </div>
              )}
              {showThinkingText && (
                <div className="flex items-center text-gray-500 font-medium">
                  <span className="animate-pulse">Thinking...</span>
                </div>
              )}

             {/* ✅ Streaming Live Response */}
            {
            streamText && connectionId === chatCtx.connectionId && (
              <div
                id="streamingTextContainer"
                className=" flex items-start gap-4 max-w-[85%] sm:max-w-[90%] rounded-xl min-w-[30%]"
              > 
                {/* {streamText} */}
                {<Markdown options={{
                    overrides: {
                      a: {
                        component: MyCustomLink,
                      },
                      table: {
                        component: MyCustomTable,
                      },
                    },
                  }}>{he.decode(streamText)}</Markdown>}
                <span className="animate-pulse"></span> {/* blinking cursor */}
              </div>)
            }
          </div>

          {/* ✅ Scroll to Bottom Button (appears when content exceeds viewport) */}
          {streamText && showScrollButton && (
            <button
              onClick={scrollToBottom}
              className="fixed bottom-24 left-1/2 -translate-x-1/2 z-50 w-8 h-8 rounded-full bg-gray-400 hover:bg-gray-300 text-white shadow-lg flex items-center justify-center transition-all duration-200 hover:scale-110 active:scale-95"
              aria-label="Scroll to bottom"
            >
              <DownOutlined className="text-sm" />
            </button>
          )}

        </div>
        {isLoading && <div className="flex justify-center items-center mb-4">
          <LoadingSpinner />
        </div>}
        <div className="absolute bottom-0 w-full p-4 pb-0 bg-white border-t">
          <ChatInput
            showPredefinedPrompts={false}
            onSend={onMessageSend2}
            isLoading={isLoading}
          />
          <p className="text-xs text-gray-500 m-0 p-0 m-1 mb-2 text-center">
            AI may make mistakes, please use with discretion.
          </p>
        </div>
      </div>
    )}
  </>
}

export default ChatBox;